import { useCallback } from 'react';

function usePreventMouseDown(params) {
  const { closeOnSelect } = params;
  const handleMouseDown = useCallback(
    (event) => {
      if (!event.isDefaultPrevented() && !closeOnSelect) {
        event.preventDefault();
      }
    },
    [closeOnSelect]
  );
  return { onMouseDown: handleMouseDown };
}

export { usePreventMouseDown };
//# sourceMappingURL=usePreventMouseDown.mjs.map
